module.exports = __webpack_public_path__ + "static/media/editing.bda44df5.svg";